/*
 *  For adding a progress bar at top of wizard for responsive view
 *
 */

define([
    'edge/platform/widgets/wizard/_WizardStepsCtrl',
    'text!./templates/wizard-step-progress.html'
], (_WizardStepsCtrl, templateStr)=> {
    return function () {
        return {
            restrict: 'A',
            replace: true,
            template: templateStr,
            require: '^gwPortalNavBar',
            controller: _WizardStepsCtrl,
            link(scope, element, attrs, navBarCtrl) {
                let wizardStepsDisplayed = false;
                scope.toggleWizardStepDisplay = () => {
                    if (wizardStepsDisplayed) {
                        navBarCtrl.hideSideBarMenu();
                        wizardStepsDisplayed = false;
                    } else {
                        navBarCtrl.showSideBarMenu();
                        wizardStepsDisplayed = true;
                    }
                };
            }
        };
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/wizard/WizardStepProgressDirective.js